import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { Opportunity, OpportunityCreate, OpportunityFilter } from '../data/opportunity';

export function createOpportunityService(client: AxiosInstance) {
  return createCrudService<Opportunity, OpportunityCreate, OpportunityFilter>(
    client,
    '/crm/Opportunity',
    'id',
  );
}

export type OpportunityService = CrudService<Opportunity, OpportunityCreate, OpportunityFilter>;
